import React, { useState, useEffect } from "react";
import "../Styles/styles.css";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import StylesForFemale from "../Components/Styles/StylesForFemale";
import SelectStyles from "../Components/Styles/SelectStyles";
import { useNavigate } from "react-router-dom";
import useTailoring from "../hooks/useTailoring";
import LoadingState from "../Components/Shared/LoadingState";
import EmptyState from "../Components/Shared/EmpytState";

const CategoryLoader = () => {
  return (
    <div className="col-lg-7 col-md-7 col-mdx-12 d-flex">
      <div class="spinner-grow spinner-grow-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p className="ms-1 mb-1">Loading...</p>
    </div>
  );
};

const FemaleStyles = ({ orderStyle, setOrderStyle }) => {
  const [sexType, setSexType] = useState("female");
  const [categories, setCategories] = useState([]);
  const [stylesCategoriesLoading, setStylesCategoriesLoading] = useState(false);
  const [stylesLoading, setStylesLoading] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All Styles");
  const [allStyles, setAllStyles] = useState([]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  const {
    handleGetStyleCategories,
    handleGetStyleByGender,
    handleGetStylesByCategory,
  } = useTailoring();

  let navigate = useNavigate();

  const handleSelect = (e) => {
    // console.log("Hello");
    setSexType(e.target.value);
    if (e.target.value === "male") {
      navigate("/tailoring/malestyle");
    } else if (e.target.value === "female") {
      navigate("/tailoring/femalestyle");
    }
  };

  const getStyleCategories = () => {
    handleGetStyleCategories()
      .then((res) =>
        setCategories([{ style_cat: "All Styles" }, ...res.data.style_cat])
      )
      .catch((err) => console.log(err))
      .finally(() => setStylesCategoriesLoading(false));
  };

  const getStylesByGender = () => {
    setStylesLoading(true);
    handleGetStyleByGender("female")
      .then((res) => setAllStyles(res.data.tailoring))
      .catch((err) => console.log(err))
      .finally(() => setStylesLoading(false));
  };

  const getStylesByCategory = () => {
    const payload = { gender: "female", category: activeCategory };
    setStylesLoading(true);
    handleGetStylesByCategory(payload)
      .then((res) => setAllStyles(res.data.tailoring))
      .catch((err) => console.log(err))
      .finally(() => setStylesLoading(false));
  };

  useEffect(() => {
    setStylesCategoriesLoading(true);
    getStyleCategories();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeCategory === "All Styles") {
      getStylesByGender();
    } else {
      getStylesByCategory();
    }
    // eslint-disable-next-line
  }, [activeCategory]);

  return (
    <div>
      <div className=" col-12 female_styles">
        <SelectStyles {...{ orderStyle, setOrderStyle }} />

        <div className=" col-12 styles_subheader">
          {stylesCategoriesLoading ? (
            <CategoryLoader />
          ) : (
            <div className="col-lg-7 col-md-7 col-mdx-12">
              {categories.map((item, index) => {
                return (
                  <button
                    onClick={() => setActiveCategory(item.style_cat)}
                    className={`${
                      activeCategory === item.style_cat ? "active" : undefined
                    } text-capitalize`}
                    key={index}
                  >
                    {item.style_cat}
                  </button>
                );
              })}
            </div>
          )}
          <div className="selectstyle col-lg-5 col-md-5 col-mdx-12">
            <div>
              <span>
                <span className="">
                  <select
                    value={sexType}
                    onChange={handleSelect}
                    className="form-select form-select-lg  shadow-none select-sex"
                    aria-label=".form-select-lg example"
                  >
                    <option value="female"> Female Styles</option>
                    <option value="male"> Male Styles</option>
                  </select>
                </span>
              </span>
            </div>
            <div className="search_icon">
              <input placeholder="Search for Styles" />
              <span>
                <i className="fas fa-search"></i>
              </span>
            </div>
          </div>
        </div>
        <div>
          {stylesLoading ? (
            <LoadingState />
          ) : allStyles ? (
            <StylesForFemale {...{ allStyles }} />
          ) : (
            <div className="py-4">
              <EmptyState />
            </div>
          )}
        </div>
        {/* <StylesForFemale /> */}
        <div className="load_more">
          <ButtonContainer cart>Load More Styles</ButtonContainer>
        </div>
        <div className="other_uploadbtn">
          <span>
            <span>Can’t find a style you want?</span>
            <span>
              <button onClick={() => setOrderStyle(true)}>
                Order a Custom Style
              </button>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FemaleStyles;
